import { useEffect } from 'react'
import { Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  supportedLanguages,
  defaultLanguage,
  type SupportedLanguage,
} from '@/i18n'
import { Layout } from './Layout'
import { ScrollToTop } from './ScrollToTop'
import {
  Home, About, Contacts, Privacy, FAQ, NotFound,
  ProductFirmo, ProductAI, ProductPA,
  ServiceDev, ServiceIntegration, ServiceTransformation, ServiceSecurity, ServiceCloud, ServiceConsulting,
  Realizzazioni
} from '@/pages'

function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  // Redirect invalid language to default
  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export function LanguageRouter() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang" element={<LanguageWrapper />}>
        {/* Home */}
        <Route index element={<Home />} />

        {/* About */}
        <Route path="chi-siamo" element={<About />} />
        <Route path="about" element={<About />} />
        <Route path="quienes-somos" element={<About />} />
        <Route path="ueber-uns" element={<About />} />
        <Route path="a-propos" element={<About />} />

        {/* Products */}
        <Route path="firmo-semplice" element={<ProductFirmo />} />
        <Route path="semplice-ai" element={<ProductAI />} />
        <Route path="semplice-pa" element={<ProductPA />} />

        {/* Services */}
        <Route path="sviluppo-software" element={<ServiceDev />} />
        <Route path="software-development" element={<ServiceDev />} />
        <Route path="desarrollo-software" element={<ServiceDev />} />
        <Route path="softwareentwicklung" element={<ServiceDev />} />
        <Route path="developpement-logiciel" element={<ServiceDev />} />
        <Route path="system-integration" element={<ServiceIntegration />} />
        <Route path="integracion-sistemas" element={<ServiceIntegration />} />
        <Route path="systemintegration" element={<ServiceIntegration />} />
        <Route path="integration-systeme" element={<ServiceIntegration />} />
        <Route path="digital-transformation" element={<ServiceTransformation />} />
        <Route path="transformacion-digital" element={<ServiceTransformation />} />
        <Route path="digitale-transformation" element={<ServiceTransformation />} />
        <Route path="transformation-digitale" element={<ServiceTransformation />} />
        <Route path="cybersecurity" element={<ServiceSecurity />} />
        <Route path="ciberseguridad" element={<ServiceSecurity />} />
        <Route path="cybersicherheit" element={<ServiceSecurity />} />
        <Route path="cybersecurite" element={<ServiceSecurity />} />
        <Route path="cloud" element={<ServiceCloud />} />
        <Route path="consulenza" element={<ServiceConsulting />} />
        <Route path="consulting" element={<ServiceConsulting />} />
        <Route path="consultoria" element={<ServiceConsulting />} />
        <Route path="beratung" element={<ServiceConsulting />} />
        <Route path="conseil" element={<ServiceConsulting />} />

        {/* Case Studies */}
        <Route path="realizzazioni" element={<Realizzazioni />} />
        <Route path="case-studies" element={<Realizzazioni />} />
        <Route path="proyectos" element={<Realizzazioni />} />
        <Route path="projekte" element={<Realizzazioni />} />
        <Route path="realisations" element={<Realizzazioni />} />

        {/* Contacts */}
        <Route path="contatti" element={<Contacts />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="contacto" element={<Contacts />} />
        <Route path="kontakt" element={<Contacts />} />
        <Route path="contact" element={<Contacts />} />

        {/* Privacy */}
        <Route path="privacy" element={<Privacy />} />
        <Route path="privacidad" element={<Privacy />} />
        <Route path="datenschutz" element={<Privacy />} />
        <Route path="confidentialite" element={<Privacy />} />

        {/* FAQ */}
        <Route path="faq" element={<FAQ />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </>
  )
}
